import { useLazyGetSignedPostPolicyQuery } from "@api/versions";
import { environment } from "@environment";
import { useState } from "react";
import { toast } from "react-toastify";

export const useUploadImage = () => {
  const [getSignedPostPolicy] = useLazyGetSignedPostPolicyQuery();
  const [loading, setLoading] = useState(false);
  const handleUploadImage = async ({
    fileType,
    blob,
    id,
  }: {
    fileType: string;
    blob: Blob | File;
    id: string;
  }) => {
    try {
      setLoading(true);
      const {
        data: { url: signeUrl, filename: bucketFileName },
      } = await getSignedPostPolicy(
        {
          type: fileType,
          bucket: environment.files,
          queryKey: id,
        },
        false,
      );

      const formData = new FormData();

      Object.entries({ ...signeUrl.fields, file: blob }).forEach(
        ([key, value]) => {
          formData.append(key, value as string | Blob);
        },
      );

      await fetch(signeUrl.url, {
        method: "POST",
        body: formData,
      });
      setLoading(false);
      const originalUrl = `https://${environment.assetsBucket}/${bucketFileName}`;
      return originalUrl;
    } catch (error) {
      console.error(error);
      toast.error("Failed to upload image, try again");
      setLoading(false);
      return null;
    }
  };
  return { handleUploadImage, loading };
};
